export default __webpack_public_path__ + "static/media/Cartes_Verso.50408b59.png";